import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import auth from "../utils/auth"
import rotas from './RotasMenu'

class LinksLns extends Component {
    componentDidMount() {
        let modulos = auth.getUserInfo().menu
        this.checkToShow(modulos)
    }

    checkToShow(modulos) {
        let menu = modulos?.find((user) => user.item === 'lns')?.endpoints
        let links = document.querySelectorAll("#item-menu")

        if (auth.isMasterOrAdmin()) {
            return
        }

        links.forEach(a => {
            let href = a.attributes.href?.nodeValue

            if (href != "/") {
                if (menu.includes(rotas['lns'][href]) === false) {
                    a.style.display = "none"
                }
            }
        })

        document.querySelectorAll("#group").forEach((group) => {
            if (group.querySelectorAll("a:not([style*='display: none'])").length === 0) {
                group.querySelector("span").style.display = "none"
            }
        })

        document.querySelectorAll(".hdv-menu-parent").forEach((group) => {
            if (group.querySelectorAll("a:not([style*='display: none'])").length === 0) {
                group.style.display = "none"
            }
        })
    }

    render() {
        return (
            <div id="scroll-menu">

                <div id="group">
                    <div className="hdv-menu-grupo">
                        <span>Sistema</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: "column" }}>
                        <Link className="hdv-submenu" id="item-menu" to="/lns/dashboard">
                            <div className={this.props.pathIncludes("/lns/dashboard")}>
                                <i className="fa fa-tachometer-alt fa-20px"></i> Dashboard
                            </div>
                        </Link>
                    </div>
                </div>

                <br/>

                <div id="group">
                    <div className="hdv-menu-grupo">
                        <span>Cadastros</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: "column" }}>
                        <Link className="hdv-submenu" id="item-menu" to="/lns/cadastro-rapido">
                            <div className={this.props.pathIncludes("/lns/cadastro-rapido")}>
                                <i className="fa fa-fast-forward fa-20px"></i> Cadastro Rápido
                            </div>
                        </Link>
                        <Link className="hdv-submenu" id="item-menu" to="/lns/application">
                            <div className={this.props.pathIncludes("/lns/application")}>
                                <i className="fa fa-project-diagram fa-20px"></i> Aplicações
                            </div>
                        </Link>
                        <Link className="hdv-submenu" id="item-menu" to="/lns/gateway">
                            <div className={this.props.pathIncludes("/lns/gateway")}>
                                <i className="fa fa-wifi fa-20px"></i> Gateways
                            </div>
                        </Link>
                        <Link className="hdv-submenu" id="item-menu" to="/lns/device/profile">
                            <div className={this.props.pathIncludes("/lns/device/profile")}>
                            <i className="fa fa-hdd fa-20px"></i> Perfis de Dispostivos
                            </div>
                        </Link>
                        <Link className="hdv-submenu" id="item-menu" to="/lns/planos">
                            <div className={this.props.pathIncludes("/lns/planos")}>
                                <i className="fa fa-file-invoice-dollar fa-20px"></i> Planos
                            </div>
                        </Link>
                        <Link className="hdv-submenu" id="item-menu" to="/lns/redirecionamentos">
                            <div className={this.props.pathIncludes("/lns/redirecionamentos")}>
                                <i className="fa fa-reply fa-20px"></i> Redirecionamentos
                            </div>
                        </Link>
                    </div>
                </div>

                <br/>

               <div id="group">
                    <div className="hdv-menu-grupo">
                        <span>Relatórios</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: "column" }}>
                        <Link className="hdv-submenu" id="item-menu" to="/lns/relatorio/gateway">
                            <div className={this.props.pathIncludes("/lns/relatorio/gateway")}>
                                <i className="fa fa-wifi fa-20px"></i> Relatório de Gateways
                            </div>
                        </Link>
                        <Link className="hdv-submenu" id="item-menu" to="/lns/relatorio/dispositivo">
                            <div className={this.props.pathIncludes("/lns/relatorio/dispositivo")}>
                                <i className="fa fa-hdd fa-20px"></i> Relatório de Dispostivos
                            </div>
                        </Link>
                        <Link className="hdv-submenu" id="item-menu" to="/lns/relatorio/faturamento">
                            <div className={this.props.pathIncludes("/lns/relatorio/faturamento")}>
                                <i className="fa fa-hand-holding-usd fa-20px"></i> Relatório de Faturamento
                            </div>
                        </Link>
                    </div>
               </div>
            </div>
        )
    }
}

export default LinksLns